import { Button, IconButton, Input, Stack, Typography } from '@mui/joy';
import { IoSearchSharp } from 'react-icons/io5';
import { MdAdd } from 'react-icons/md';

import Table from '../../components/table';

import { Breadcrumbs } from './components/Breadcrumbs';
import { StubAICreditsCard } from './components/StubAICreditsCard';
import { cellRenderOrder, columns, STUB_SAMPLE_PROJECTS } from './constants';

const ProjectScreenerStub = () => {
  return (
    <>
      <Breadcrumbs />
      <Stack gap={2} px={3} py={'12px'}>
        <Stack direction='row' justifyContent='space-between' alignItems='flex-start'>
          <Stack>
            <Typography level='h4' color='primary' fontWeight='bold'>
              SmartScan
            </Typography>
            <Typography
              level='title-lg'
              fontWeight='md'
              sx={{ color: (theme) => theme.palette.text.tertiary }}
            >
              AI-powered screening of your project documentation
            </Typography>
          </Stack>
          <StubAICreditsCard />
        </Stack>

        <Stack direction='row' justifyContent='space-between' alignItems='center' gap={2}>
          <Input
            placeholder='Search screened projects'
            variant='outlined'
            disabled
            endDecorator={
              <IconButton disabled>
                <IoSearchSharp size={24} />
              </IconButton>
            }
            sx={{ maxWidth: 400, flexGrow: 1, height: 44 }}
          />
          <Button variant='solid' size='md' startDecorator={<MdAdd size={24} />} disabled>
            New screening
          </Button>
        </Stack>

        <Table
          columns={columns}
          cellRenderOrder={cellRenderOrder}
          data={STUB_SAMPLE_PROJECTS}
          rowKey='id'
          scrollArea='both'
          isStickyHeader
          bodyStyle={{ height: 'calc(100vh - 370px)' }}
          style={{
            '--TableCell-paddingY': '6px',
            '--TableCell-paddingX': '16px',
          }}
        />
      </Stack>
    </>
  );
};

export { ProjectScreenerStub };
